import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import useReveal from "../../hooks/useReveal";
import "./FAQSection.css";

/** FAQPage structured data for rich results, derived from the FAQ content. */
const buildFaqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs
    .filter((faq) => typeof faq.answer === "string")
    .map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: { "@type": "Answer", text: faq.answer },
    })),
});

const FAQSection = ({ faqs, intro }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const sectionRef = useReveal();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section ref={sectionRef} className="faq-section reveal">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(buildFaqJsonLd(faqs)) }}
      />

      <div className="faq-container">
        <div className="faq-intro">
          <h2>{intro.title}</h2>
          <h3>{intro.subtitle}</h3>
          <p>{intro.description}</p>
        </div>

        <div className="faq-items">
          {faqs.map((faq, index) => {
            const isOpen = activeIndex === index;
            return (
              <div key={faq.id} className={`faq-item ${isOpen ? "open" : ""}`}>
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <FaChevronDown className={`faq-icon ${isOpen ? "rotate" : ""}`} aria-hidden="true" />
                </button>
                <div className="faq-answer">
                  <div className="faq-answer-inner">
                    <p className="faq-answer-text">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
